export default __webpack_public_path__ + "static/media/1.fdafae5e.jpg";